import makeNoopPlugin from "/home/nic/Documents/dev/babel/babel/packages/babel-standalone/src/make-noop-plugin.ts"; export default makeNoopPlugin()